import { ServiceInspectKey } from "./key";
import { useBaseQuery } from "../baseQuery";
import { PapyrusServiceInspectUrl } from "@maven-rest/papyrus/Inspect.url";

export function usePapyrusServiceInspectQuery() {
  return useBaseQuery({
    queryKey: [ServiceInspectKey.PapyrusInspect],
    fnOption: {
      host: process.env.REACT_APP_PAPYRUS_BE_URL,
      url: PapyrusServiceInspectUrl.inspect,
    },
    allowWithoutSession: true,
  });
}
